import { spacing, color } from "@universityofmaryland/web-token-library";
import "../../typography/font-face/index.js";
import "../../typography/campaign.js";
import "../../typography/elements.js";
import { larger } from "../../typography/sans.js";
import "../../typography/serif.js";
import "../../typography/stats.js";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/postcss/lib/postcss.js";
import "../../node_modules/postcss-js/index.js";
import "../../node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-text-quote";
const quote = objectWithClassName({
  className: [
    `${classNamePrefix}`,
    /** @deprecated Use 'umd-text-quote' instead */
    `umd-rich-text-inline-quote`
  ],
  "& blockquote": {
    ...larger,
    ...{
      display: "inline-block",
      borderLeft: `2px solid ${color.red}`,
      position: "relative",
      paddingLeft: spacing.md
    }
  }
});
export {
  quote
};
//# sourceMappingURL=quote.js.map
